import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { CodeSystemListComponent } from 'app/mdm/terminology/codesystem/containers/codesystem-list.component';
import { CodeSystemService } from 'app/mdm/terminology/codesystem/services/codesystem.service';
import { CodeSystemEditComponent } from 'app/mdm/terminology/codesystem/containers/codesystem-edit.component';
import { CodeSystemViewComponent } from 'app/mdm/terminology/codesystem/containers/codesystem-view.component';
import { CodeSystemConceptEditComponent } from 'app/mdm/terminology/codesystem/containers/codesystem-concept-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';

export const CS_ROUTES: Routes = [
  { path: '', component: CodeSystemListComponent },
  { path: 'view/:id', component: CodeSystemViewComponent },
  { path: 'edit/:id', component: CodeSystemEditComponent },
  { path: 'add', component: CodeSystemEditComponent },

  { path: ':csid/concepts/edit/:id', component: CodeSystemConceptEditComponent },
  { path: ':csid/concepts/add', component: CodeSystemConceptEditComponent },
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    TerminologyLibModule,
    ReactiveFormsModule,
  ],
  declarations: [
    CodeSystemListComponent,
    CodeSystemViewComponent,
    CodeSystemEditComponent,
    CodeSystemConceptEditComponent,
  ],
  providers: [CodeSystemService],
})
export class CodeSystemModule {}
